var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,16C123.7,16,16,123.7,16,256s107.7,240,240,240s240-107.7,240-240S388.3,16,256,16z M448,176H362 c-7.5-48.6-21.9-89.3-40.9-117.4C378.4,77.5,424.8,120.7,448,176z M336,256c0,16.8-0.9,32.8-2.3,48H178.3c-1.5-15.2-2.3-31.2-2.3-48 s0.9-32.8,2.3-48h155.4C335.1,223.2,336,239.2,336,256z M256,464c-28.9,0-60.2-49.9-73.5-128h147C316.2,414.1,284.9,464,256,464z  M182.5,176C195.8,97.9,227.1,48,256,48s60.2,49.9,73.5,128H182.5z M190.9,58.6c-19,28.1-33.4,68.8-40.9,117.4H64 C87.2,120.7,133.6,77.5,190.9,58.6z M53.8,208h92.3c-1.4,15.4-2.1,31.4-2.1,48s0.8,32.6,2.1,48H53.8c-3.7-15.4-5.8-31.5-5.8-48 S50.1,223.4,53.8,208z M64,336H150c7.5,48.6,21.9,89.3,40.9,117.4C133.6,434.5,87.2,391.3,64,336z M321.1,453.4 c19-28.1,33.4-68.8,40.9-117.4H448C424.8,391.3,378.4,434.5,321.1,453.4L321.1,453.4z M458.2,304h-92.3c1.4-15.4,2.1-31.4,2.1-48 s-0.8-32.6-2.1-48h92.3c3.7,15.4,5.8,31.5,5.8,48S461.9,288.6,458.2,304z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.c039058e.svg";
export { ForwardRef as ReactComponent };